import React from 'react'
import CommentDialog from '../../../../components/CommentsPopUp'
import JobJournalComments from "./index";

const JobJournalCommentsDialog = ({onClose, onPost,projectId,project,formId, ...props}) =>
    <CommentDialog
        {...props} onClose={onClose}

        body={<JobJournalComments {...props} onClose={onClose} projectId={projectId} project={project} formId={formId} />}

    />

export default JobJournalCommentsDialog;